export default __webpack_public_path__ + "static/media/cardbg.b644231f.png";